import React from 'react';
import {render} from 'react-dom';
import FerrySearchMask from './FerrySearchMask';
import createSearchMaskStore from './FerrySearchMask/FerrySearchMaskStore';

const searchMaskStore = createSearchMaskStore();

if (searchMaskStore.darkMode) {
  document.documentElement.classList.add('dark-mode');
  const body = document.body;
  body.style.minHeight = '100vh';
  body.style.margin = '0';
  body.style.border = '1px solid #555';
  body.style.boxSizing = 'border-box';
}

render((
  <FerrySearchMask store={searchMaskStore} />
), document.getElementById('ferrySearchMaskAffiliates'));
